<template>
  <iColumn align="center">
    <iSubHeading
      variant="standard"
    >
      Let's get you set up. Enter your details below.
    </iSubHeading>
    <iTextInput
      v-model="userAuthEmail"
      placeholder="Email"
      disabled
      width="fill"
    />
    <iTextInput
      v-model="userFirstName"
      placeholder="First Name"
      width="fill"
      focus
    />
    <iTextInput
      v-model="userLastName"
      placeholder="Last Name"
      width="fill"
    />
    <iTextInput
      v-model="password"
      placeholder="Password"
      width="fill"
      type="password"
    />
    <PasswordComplexity
      v-if="password"
      :password="password"
      @update:password="validatePasswordComplexity"
    />
    <iTextInput
      v-model="confirmPassword"
      placeholder="Confirm Password"
      width="fill"
      type="password"
      @enter="completeSignUp"
    />
    <iText v-if="signupErrorMessage" variant="error">
      {{ signupErrorMessage }}
    </iText>
    <iButton
      :is-loading="isLoading"
      loading-spinner-position="inside"
      :disabled="isLoading || !validPassword"
      @click="completeSignUp"
    >
      Continue
    </iButton>
    <iSpace :height="40" width="fill" />
    <PoweredByInspiration />
  </iColumn>
</template>

<script>
import PoweredByInspiration from "%/dynamic-component-editor/standard-pages/login-signup-page/join-publication/PoweredByInspiration.vue";
import { mapActions, mapState, mapWritableState } from "pinia";
import PasswordComplexity from "%/dynamic-component-editor/components/PasswordComplexity.vue";
import { useLoginSignupStore } from "%/dynamic-component-editor/stores/login-signup-store";

export default {
  name: "JoinPublicationCompleteAccount",
  components: { PasswordComplexity, PoweredByInspiration },
  data() {
    return {
      validPassword: false,
      password: "",
      confirmPassword: "",
    };
  },
  computed: {
    ...mapWritableState(useLoginSignupStore, [
      "userAuthEmail",
      "userFlowSteps",
      "userFirstName",
      "userLastName",
      "signupErrorMessage",
    ]),
    ...mapState(useLoginSignupStore, [
      "isLoading",
    ]),
    isSignupFormValid() {
      return this.validateSignupFormData(
        this.userFirstName,
        this.userLastName,
        this.userAuthEmail,
        this.password,
        this.confirmPassword,
      );
    },
  },
  mounted() {
    this.signupErrorMessage = "";
  },
  methods: {
    ...mapActions(useLoginSignupStore, [
      "signUpAndAcceptInvitation",
      "validateSignupFormData",
    ]),
    completeSignUp() {
      if (!this.isSignupFormValid) {
        return;
      }
      this.signUpAndAcceptInvitation(this.password);
    },
    validatePasswordComplexity(value) {
      this.validPassword = value;
    },
  },
};
</script>
